module.exports = __webpack_public_path__ + "img/6tirMov.5802230d.png";